import { Component, OnInit, Renderer2, ElementRef, ViewChild, HostListener, AfterViewInit, Inject } from '@angular/core';
import { Paginacao } from '@app/models/util/paginacao';
import { ProcessoService } from '@app/services/processo.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ProcessoConsulta } from '@app/models/processo.model';
import { BuscarProcessosModel } from '@app/pages/processos/buscar-processos/model';
import debounce from '@app/utils/debounce';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-buscar-processos',
  templateUrl: './buscar-processos.component.html',
  styleUrls: ['./buscar-processos.component.scss']
})
export class BuscarProcessosComponent implements OnInit {
  buscarProcessosModel: BuscarProcessosModel = new BuscarProcessosModel();
  paginacao: Paginacao = new Paginacao(1, 0, 5, 10);
  listaProcessos: ProcessoConsulta[] = [];
  filtroDescricao = '';
  clienteId = '';
  loading = true;
  pesquisaPorClienteId: boolean = false;
  desbloquearPesquisaPorClienteId: boolean = false;
  pesquisando: boolean;
  pesquisandoArquivados: boolean;
  botaoDesabilitado: boolean = false;
  buscarProcesso = '';

  limitePagina = 10;
  _debounce: any;
  _descricao = '';
  _pagina = 1;

  @ViewChild('inputBuscar', { static: true }) inputBuscar: ElementRef;
  filtroCampo: string;

  @HostListener('document:keydown', ['$event'])
  atalhoGravar(event: KeyboardEvent) {
    if (event.which === 13 || event.keyCode === 13) { // TODO: remover o which e keycode
      event.preventDefault();
      this.onKeyPress;
    }
  }

  constructor(private processoService: ProcessoService,
    private route: ActivatedRoute, private router: Router,
    private renderer: Renderer2,
    @Inject(ToastrService) public toastr: ToastrService
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.filtroDescricao = params['busca'];
      this.clienteId = params['clienteId'];
      if(this.clienteId){
        this.pesquisaPorClienteId = true;
      }
    });
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar(arquivados: boolean = false) {
    this.buscarProcessosModel.Arquivados = arquivados;
    this.pesquisando = !arquivados;
    this.pesquisandoArquivados = arquivados;
    this.obterTodos(this.filtroDescricao, this.paginacao.paginaAtual);
    this.paginacao.paginaAtual = 1;
  }

  onKeyPress(event: KeyboardEvent, arquivos: boolean = false) {
  this.pesquisando = !arquivos;
  this.pesquisandoArquivados = arquivos;
  this.buscarProcessosModel.FiltroDescricao = this.filtroDescricao;
  this.buscarProcessosModel.Arquivados = arquivos;

  if (this.buscarProcessosModel.FiltroDescricao.length >= 3 || this.buscarProcessosModel.FiltroDescricao.length == 0) {
    this.obterTodos(this.buscarProcessosModel.FiltroDescricao, 1);
  }
  this.paginacao.paginaAtual = 1;
}

  obterTodos(descricao: string, pagina: number) {
  this.buscarProcessosModel.FiltroDescricao = '';
  if (this.pesquisaPorClienteId) {
    descricao = this.clienteId;
    this.buscarProcessosModel.FiltroCampo = 'clienteId';
  }

  this._descricao = descricao;
  this.buscarProcessosModel.FiltroDescricao = descricao;
  this._pagina = pagina;
  this.buscarProcessosModel.Pagina = pagina;

  this.processoService.obterBusca(this.buscarProcessosModel).subscribe(
    data => {    
      this.listaProcessos = data.Dados;
      this.listaProcessos.forEach(processoConsulta => {
        processoConsulta.ListaGrupoInstancia = new Map();
        processoConsulta.InformacoesProcessoInstancia.forEach(instancia => {
          if(!processoConsulta.ListaGrupoInstancia.has(instancia.DescricaoInstancia)){
            processoConsulta.ListaGrupoInstancia.set(instancia.DescricaoInstancia, [instancia]);
          } else {
            let temp = processoConsulta.ListaGrupoInstancia.get(instancia.DescricaoInstancia)
            processoConsulta.ListaGrupoInstancia.set(instancia.DescricaoInstancia, [...temp,instancia]);
          }
        })
      });

      this.paginacao.totalDeItens = data.Total; 
      this.pesquisandoArquivados = false;
      this.loading = false;
    },
    erro => {
      console.error("Erro na requisição:", erro);
      this.loading = false;
      this.pesquisandoArquivados = false;
    }
  );
}

  public pageChanged(event: any): void {
    this._pagina = event.page; 
    this.obterTodos(this.filtroDescricao, this._pagina); 
  }

  ngOnDestroy(): void {
  }
}